import React, { useContext } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import { userContext } from '../contextProvider/Authentication';

const PopupAlert = (props) => {

    const { commonData, setCommonData } = useContext(userContext);

    return (
        <>
            {
                commonData?.showPopupAlert &&
                <div>
                    {
                        commonData?.needCancel ?
                            <SweetAlert
                                success
                                title={commonData?.title}
                                onConfirm={() => commonData?.onConfirm()}
                                confirmBtnText="Confirm"
                                confirmBtnBsStyle="primary"
                                showCancel={commonData?.showCancel}
                                cancelBtnBsStyle="danger"
                                btnSize="md"
                                reverseButtons={true}
                                onCancel={() => setCommonData({ ...commonData, showPopupAlert: false })}
                            />
                            :
                            <SweetAlert
                                success
                                title={commonData?.title}
                                onConfirm={commonData?.onConfirm}
                                confirmBtnText="Confirm"
                                confirmBtnBsStyle="primary"
                                btnSize="md"
                                reverseButtons={true}
                            />
                    }

                </div>
            }
        </>
    );
}

export default PopupAlert;